<template>
    <div class="container">
        <div class="hill-section" id="residence">
            <h3 class="title">Residence Service</h3>
            <p class="intro">108Hill provides the impressive facilities with great location to live and work accommodating your busy lifestyle, from location to functionality and everything in-between. It’s surrounded by the convenience environment such as JOMA café, mini marts, Sengdara Fitness, 3 minutes’ drive to Thongphanthong fresh market, etc.
</p>
            <div class="columns is-multiline is-hidden-mobile">
                <div class="column is-4" v-for="img in office" :key="img.id">
                    <div class="image-gal">
                        <img v-lazy="img.img" alt="">
                    </div>
                </div>
            </div>
            <div class="is-hidden-desktop">
                <div class="columns is-multiline slider-for">
                    <div class="column is-4" v-for="img in office" :key="img.id">
                        <div class="image-gal">
                            <img v-lazy="img.img" alt="">
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline slider-nav">
                    <div class="column is-4" v-for="img in office" :key="img.id">
                        <div class="image-gal">
                            <img v-lazy="img.img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                office:[
                    {img: '/image/room1.jpg'},
                    {img: '/image/room2.jpg'},
                    {img: '/image/room3.jpg'},
                    {img: '/image/room4.jpg'},
                    {img: '/image/room5.jpg'},
                    {img: '/image/room6.jpg'},
                    {img: '/image/room7.jpg'},
                    {img: '/image/room8.jpg'},
                    {img: '/image/room9.jpg'}
                ]
            }
        },
        methods: {
            ResMobileSlider(){
                $('.slider-for').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '.slider-nav'
                });
                $('.slider-nav').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: '.slider-for',
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true,
                    arrows: false
                });
            } 
        },
        mounted(){
            this.ResMobileSlider();
        }
    }
</script>

<style lang="scss" scoped>
    .columns{
        margin: 0;
        padding: 0;
        .column{
            margin: 0;
            padding: 5px;
            &:first-child{
                margin: 0;
                padding-bottom: 5px;
            }
            .slick-slide.slick-current.slick-active.slick-center{
                border: 1px solid $color-sub;
            }
            .image-gal{
                position: relative;
                overflow: hidden;
                &::before{
                    display: block;
                    content: "";
                    width: 100%;
                    padding-top: 70%;
                }
                img{
                    height: 100%;
                    -o-object-fit: cover;
                    object-fit: cover;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                }
            }
        }
    }
</style>